// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"esIbd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productPage", ()=>productPage);
var _core = require("@xatom/core");
var _utils = require("../../utils");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _config = require("../../config");
const productPage = async ()=>{
    const compareButton = new (0, _core.WFComponent)(`[xa-type='compare-btn']`);
    const insideTheBoxVideo = new (0, _core.WFComponent)(`[xa-type="inside-the-box-video"]`);
    const buySampleNowButton = new (0, _core.WFComponent)(`[xa-type="buy-sample-now"]`);
    const nutritionFactsSection = new (0, _core.WFComponent)(`[xa-type="nutritional-facts-section"]`);
    compareButton.on("click", async ()=>{
        (0, _utils.gaEventTrigger)(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Compare Button Clicked");
    });
    insideTheBoxVideo.on("click", async ()=>{
        (0, _utils.gaEventTrigger)(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Inside The Box Video Clicked");
    });
    buySampleNowButton.on("click", async ()=>{
        (0, _utils.gaEventTrigger)(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Buy Sample Now Button Clicked");
    });
    nutritionFactsSection.on("click", async ()=>{
        (0, _utils.gaEventTrigger)(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Nutrition Facts Section Clicked");
    });
    const token = localStorage.getItem("_ms-mid");
    const categorySlug = new (0, _core.WFComponent)(`[xa-type='product-category-slug']`).getText();
    const result = (await (0, _axiosDefault.default).get(`${(0, _config.API_ENDPOINT)}/airtable/category/fields?categorySlug=${categorySlug}`, {
        headers: {
            authorization: `Bearer ${token}`
        }
    })).data.data;
    if (result?.fields?.["Texture Fields"]?.length > 0) {
        const textureFields = result?.fields?.["Texture Fields"].split(",").map((item)=>item.trim());
        textureFields.forEach((item, index)=>{
            const textureField = new (0, _core.WFComponent)(`[xa-type='texture-${index + 1}']`);
            textureField.setText(item);
        });
    } else console.log("No fields found!");
};

},{"@xatom/core":"5eqAK","../../utils":"jzxvl","axios":"emMR8","../../config":"3LaYJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzxvl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gaEventTrigger", ()=>gaEventTrigger);
parcelHelpers.export(exports, "authErrorHandler", ()=>authErrorHandler);
const gaEventTrigger = async (pageTitle, action)=>{
    gtag("event", "coming soon", {
        "page_title": pageTitle || "Untitled Page",
        "action": action || "Untitled Action"
    });
};
const authErrorHandler = (error)=>{
    if (error.message === "Authentication failed" || error.message.toLowerCase().includes("unauthorized")) console.error("Authentication failed. Please log in again.");
    else console.error("An unexpected error occurred:", error);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},[], null, "parcelRequire2e46")

//# sourceMappingURL=product.f0eda28f.js.map
